import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { visuallyHidden } from "@mui/utils";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {
  RemoveRedEyeIcon,
  SearchIcon,
  EditIcon,
  DownloadIcon,
  CloudOffIcon,
  RestartAltIcon,
} from "../../../Resources/Icons/icons";
import moment from "moment";
import { Divider, Stack, Badge } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

import {
  GetPolicyFileById,
  DeleteBranch,
  GetCompany,
  GetBookingCode,
  GetPolicyFindbyId,
  GetCommisionReceivableAmount,
  GetReceivablePayablePercentage,
  ReframeEndDateTimeFormat,
  FilterPolicyList,
} from "../../../Service/_index";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CommonPayableDrawer from "../CommonPayableDrawer/CommonPayableDrawer";
import { PolicyFilterTypes } from "../../../Shared/CommonConstant";
import Loader from "../../../UiComponents/Loader/Loader";
import { DatePicker, Radio } from "antd";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import FilterListIcon from "@mui/icons-material/FilterList";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import HistoryIcon from "@mui/icons-material/History";
import BulkUploadPayableDialog from "../BulkUpload/BulkUploadPayableDialog";
import BulkUploadHistoryDialog from "../BulkUpload/BulkUploadHistoryDialog";
import {
  VerifyCommisionReceivableBulkUpload,
  BulkUploadCommisionReceivable,
} from "../../../Service/BulkUploadService";

const { RangePicker } = DatePicker;

const COMMISION_RECEIVABLE_TEMPLATE_HEADERS = [
  "Policy Number",
  "Commission OD %",
  "Commission OD Amt",
  "Commission TP %",
  "Commission TP Amt",
  "Commission Net %",
  "Commission Net Amt",
  "Commission Total",
];

const getClassName = (data) => {
  // return data.policyNumber ? "file_link" : data.CLEAR ? "button-clear" : data.bounce ? "button-bounce": "button-bounce";
  return data.policyNumber ? "file_link" : "";
};

const headCells = [
  {
    id: "issueData",
    placeMent: true,
    disablePadding: false,
    label: "Policy Date",
    type: "date",
  },
  {
    id: "companyName",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
    class: getClassName,
    onClick: true,
  },
  {
    id: "customerName",
    placeMent: true,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "product",
    placeMent: true,
    disablePadding: false,
    label: "Product",
  },
  {
    id: "policyType",
    placeMent: true,
    disablePadding: false,
    label: "Policy Type",
  },
  {
    id: "registerationNumber",
    placeMent: true,
    disablePadding: false,
    label: "Reg Number",
  },
  {
    id: "paymentMode",
    placeMent: true,
    disablePadding: false,
    label: "Payment Type",
  },
  {
    id: "receivableAmount",
    placeMent: true,
    disablePadding: false,
    label: "Receivable Amount",
  },
  {
    id: "dynamicAction",
    placeMent: true,
    disablePadding: false,
    label: "Action",
    type: "dynamicAction",
  },
  // {
  //   id: "action",
  //   placeMent: false,
  //   disablePadding: false,
  //   label: "Action",
  // },
];

const CommisionReceivable = () => {
  const [openFilter, setOpenFilter] = React.useState(false);
  const [openFilterDropdown, setOpenFilterDropdown] = React.useState(true);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [policyList, setPolicyList] = React.useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [formType, setFormType] = useState("");
  const [selectedComapny, setSelectedCompany] = useState(null);
  const [selectedBookingCode, setSelectedBookingCode] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [resetValue, setResetValue] = useState(1);
  const [payableType, setPayableType] = useState("");
  const [filterType, setFilterType] = useState("PENDING");
  const [editType, setEditType] = useState("");
  const [payablePercentage, setPayablePercentage] = useState({});
  const [selectedPolicyNumber, setSelectedPolicyNumber] = useState("");
  const [searchText, setSearchText] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);
  const UserType = sessionStorage.getItem("userType");
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  console.log("totalCount", totalCount);
  const [dateRange, setDateRange] = useState();
  const [queryParam, setQueryParam] = useState({
    isPaginationEnabled: true,
    page: 1,
    limit: 10,
    skip: 0,
    search: "",
    sort: "",
  });

  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [tableConfig, setTableConfig] = useState({
    isAction: false,
    isView: false,
    isEdit: false,
    isDelete: false,
    isSearch: false,
    isApprove: false,
  });

  React.useEffect(() => {
    GetData(true);
  }, [queryParam]);

  const ApproveFunction = (row, key) => {
    if (row.isCommisionRecievable) {
      let key = "Edit";
      setOpenLoader(true);
      GetPolicyFindbyId(row._id)
        .then((res) => {
          setSelectedData(res.data);
        })
        .then(() => {
          GetReceivablePayablePercentage(row._id).then((res) => {
            setOpenDrawer(true);
            setFormType("edit");
            setPayableType("commisionReceivable");
            setEditType(key);
            setOpenLoader(false);
            setPayablePercentage(res?.data);
          });
        });
    } else {
      let key = "Approve";
      setOpenLoader(true);
      GetPolicyFindbyId(row._id)
        .then((res) => {
          setSelectedData(res.data);
        })
        .then(() => {
          GetReceivablePayablePercentage(row._id).then((res) => {
            setOpenDrawer(true);
            setFormType("edit");
            setPayableType("commisionReceivable");
            setEditType(key);
            setOpenLoader(false);
            setPayablePercentage(res?.data);
          });
        });
    }
  };

  const GetPolicyFindbyIdFunction = (row) => {
    setOpenLoader(true);
    GetPolicyFindbyId(row._id).then((res) => {
      setOpenLoader(false);
      setSelectedData(res.data);
      setOpenDrawer(true);
      setFormType("view");
    });
  };

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const modifiedCompanyDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      console.log(modifiedCompanyDetails);
      setCompanyDetails(modifiedCompanyDetails);
    });
  };
  const GetBookingCodeDetails = () => {
    GetBookingCode({ isAscending: true }).then((res) => {
      const modifiedBookingCode = res.data.map((e) => {
        return {
          ...e,
          label: e.bookingCode,
          value: e._id,
        };
      });
      setBookingCodeDetails(modifiedBookingCode);
    });
  };
  React.useEffect(() => {
    GetCompanyDetails();
    GetBookingCodeDetails();
  }, []);

  const GetData = async (isPaginationAction) => {
    if (!selectedPolicyNumber) {
      if (!filterType) {
        ToastError("Please select Filter Type");
        return true;
      }
      if (
        filterType != FilterOptions[0].type &&
        (!selectedStartDate || !selectedEndDate)
      ) {
        ToastError("Please select date range");
        return true;
      }
    }

    setOpenLoader(true);
    let endDate = null;
    if (selectedEndDate) {
      endDate = await ReframeEndDateTimeFormat(selectedEndDate);
    }
    FilterPolicyList({
      companyId: selectedComapny,
      bookingCodeId: selectedBookingCode,
      startDate: selectedStartDate,
      policyNumber: selectedPolicyNumber,
      endDate: endDate,
      type: filterType,
      FilterType: "UTILITES_SCREEN",
      screen: "COMMISION_RECIVABLE",
      ...queryParam,
    })
      .then((res) => {
        setOpenLoader(false);
        const data = res.data.map((e) => {
          return {
            ...e,
            // formateDate: moment(e.issueDate).format("DD/MM/YYYY"),
            formateDate:
              filterType === "APPROVE_DATE"
                ? moment(e.commisionRecievable?.updatedAt).format(
                    "DD/MM/YYYY hh:mm A",
                  )
                : moment(e.issueDate).format("DD/MM/YYYY hh:mm A"),
          };
        });

        setPolicyList(data);
        // setTotalCount(res?.data?.[0]?.totalRecord || 0);
        if (data.length > 0) {
          setTotalCount(data[0].totalRecord || 0);
        } else {
          setTotalCount(0);
        }
        // Added by Arun
        if (!isPaginationAction) {
          setPageIndex(0);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setOpenLoader(false);
      });
  };
  React.useEffect(() => {
    GetData();
  }, [pageIndex, pageSize, searchText]);
  const ResetFilter = () => {
    setSelectedCompany(null);
    setSelectedBookingCode(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setResetValue(resetValue + 1);
    GetData();
  };

  const OpenPolicyFile = (row) => {
    setOpenLoader(true);
    GetPolicyFileById(row?._id)
      .then((res) => {
        const pdfUrl = res?.data?.policyFile?.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        setOpenLoader(false);
        const blobData = base64toBlob(pdfUrl, "application/pdf");
        const blobUrl = URL.createObjectURL(blobData);
        setOpenLoader(false);
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          `<embed src="${blobUrl}" width="100%" height="100%" />`,
        );
      });
  };

  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  const header = [
    { label: "Policy Date", key: "formateDate" },
    { label: "Company Name", key: "companyId.shortName" },
    { label: "Policy Number", key: "policyNumber" },
    { label: "Customer Name", key: "customerName" },
    { label: "Mobile", key: "userId.mobileNumber" },
    { label: "Payment Mode", key: "paymentMode" },
    { label: "Reg Number", key: "registrationNumber" },
    { label: "User Email", key: "userId.email" },
  ];
  // Export fetches every record for the current filters, not just the page
  const csvLinkRef = useRef();
  const [exportData, setExportData] = useState([]);
  const csvFile = {
    filename: "Commision Receivable Data",
    headers: header,
    data: exportData,
  };

  const exportAllRecords = async () => {
    if (!selectedPolicyNumber) {
      if (!filterType) {
        ToastError("Please select Filter Type");
        return;
      }
      if (
        filterType != FilterOptions[0].type &&
        (!selectedStartDate || !selectedEndDate)
      ) {
        ToastError("Please select date range");
        return;
      }
    }
    setOpenLoader(true);
    try {
      let endDate = null;
      if (selectedEndDate) {
        endDate = await ReframeEndDateTimeFormat(selectedEndDate);
      }
      const res = await FilterPolicyList({
        companyId: selectedComapny,
        bookingCodeId: selectedBookingCode,
        startDate: selectedStartDate,
        policyNumber: selectedPolicyNumber,
        endDate: endDate,
        type: filterType,
        FilterType: "UTILITES_SCREEN",
        screen: "COMMISION_RECIVABLE",
        ...queryParam,
        isPaginationEnabled: false,
        page: 0,
        skip: 0,
      });
      setExportData(
        res.data.map((e) => ({
          ...e,
          formateDate:
            filterType === "APPROVE_DATE"
              ? moment(e.commisionRecievable?.updatedAt).format(
                  "DD/MM/YYYY hh:mm A",
                )
              : moment(e.issueDate).format("DD/MM/YYYY hh:mm A"),
        })),
      );
      // Let the CSV link pick up the new data before it is clicked
      setTimeout(() => csvLinkRef.current?.link?.click(), 0);
    } catch (err) {
      console.log(err);
    } finally {
      setOpenLoader(false);
    }
  };

  const FilterOptions = [
    {
      label: "Pending",
      FilterType: "UTILITES_SCREEN",
      screen: "USER_PAYABLE",
      type: "PENDING",
      _id: "PENDING",
    },
    {
      label: "Issue Date",
      FilterType: "UTILITES_SCREEN",
      screen: "USER_PAYABLE",
      type: "ISSUE_DATE",
      _id: "ISSUE_DATE",
    },
    {
      label: "Approve Date",
      FilterType: "UTILITES_SCREEN",
      screen: "USER_PAYABLE",
      type: "APPROVE_DATE",
      _id: "APPROVE_DATE",
    },
    {
      label: "Cancel Date",
      FilterType: "UTILITES_SCREEN",
      screen: "USER_PAYABLE",
      type: "CANCEL_DATE",
      _id: "CANCEL_DATE",
    },
  ];

  const handleClearAllState = () => {
    setSelectedCompany(null);
    setSelectedBookingCode(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setFilterType("PENDING");
    setSelectedPolicyNumber(null);
    setQueryParam({
      isPaginationEnabled: true,
      page: 0,
      limit: 10,
      skip: 0,
      search: "",
      sort: "",
    });
    setPageIndex(0);
  };

  const handleClearSingleFilter = (filterId) => {
    if (filterId === 1) {
      setSelectedCompany(null);
    } else if (filterId === 2) {
      setSelectedBookingCode(null);
    } else if (filterId === 3) {
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    } else if (filterId === 4) {
      setFilterType("PENDING");
    } else if (filterId === 5) {
      setSelectedPolicyNumber(null);
    }
    setQueryParam({
      isPaginationEnabled: true,
      page: 0,
      limit: 10,
      skip: 0,
      search: "",
      sort: "",
    });
    setPageIndex(0);
  };

  const [searchTrigger, setSearchTrigger] = useState(0);

  const handleSaveAllFilter = () => {
    setSearchTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    if (searchTrigger > 0) {
      setPageIndex(0); // Reset to first page when applying filters
      setQueryParam({
        isPaginationEnabled: true,
        page: 0,
        limit: 10,
        skip: 0,
        search: "",
        sort: "",
      });
      GetData();
    }
  }, [searchTrigger]);

  useEffect(() => {
    if (dateRange && Array.isArray(dateRange) && dateRange.length === 2) {
      setSelectedStartDate(dateRange[0]);
      setSelectedEndDate(dateRange[1]);
    } else if (!dateRange || dateRange.length === 0) {
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    }
  }, [dateRange]);

  const filterBoxData = [
    {
      id: 1,
      label: "Select Company",
      data: companyDetails,
      setState: setSelectedCompany,
      value: selectedComapny,
      type: "input",
      variation: "single",
    },
    {
      id: 2,
      label: "Company code",
      data: bookingCodeDetails,
      setState: (v) => {
        console.log("code details: ", bookingCodeDetails);
        setSelectedBookingCode(v);
      },
      value: selectedBookingCode,
      type: "input",
      variation: "single",
    },
    {
      id: 3,
      label: "Date Range",
      setDate: (range) => {
        setDateRange(range);
        setSearchTrigger((prev) => prev + 1);
      },
      value: dateRange,
      type: "noDefaultDate",
    },
    {
      id: 4,
      label: "Filter Type",
      data: FilterOptions,
      setState: (e) => {
        let option = FilterOptions.find((el) => el._id === e);
        if (option) {
          setFilterType(option.type);
        }
      },
      type: "input",
      variation: "single",
      value: FilterOptions.find((option) => option.type === filterType)?._id,
    },
    {
      id: 5,
      label: "Policy Number",
      setState: setSelectedPolicyNumber,
      value: selectedPolicyNumber,
      type: "normalInput",
    },
  ];
  const activeFiltersCount = [
    selectedComapny,
    selectedBookingCode,
    filterType,
    selectedPolicyNumber,
    dateRange?.[0] ? 1 : 0,
  ].filter(Boolean).length;

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems="center"
                className="Master_Card_Sub_Container"
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Typography className="Master_Card_Tittle">
                    Commision Receivable
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                  >
                    <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap" sx={{ width: "100%" }}>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <Badge
                            badgeContent={activeFiltersCount}
                            color="error"
                            sx={{
                              "& .MuiBadge-badge": {
                                right: 5,
                                top: 3,
                                width: "14px",
                                height: "14px",
                                minWidth: "14px",
                                borderRadius: "50%",
                                fontSize: "8.91px",
                                fontWeight: "600",
                                backgroundColor: "#E50000",
                                color: "#fff",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <FilterListIcon sx={{ marginRight: "1.5px" }} />
                          </Badge>
                        }
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        Filters
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <CloudDownloadOutlinedIcon
                            sx={{
                              color: "#344054",
                            }}
                          />
                        }
                        onClick={exportAllRecords}
                      >
                        Export
                      </Button>
                      <CSVLink
                        ref={csvLinkRef}
                        style={{ display: "none" }}
                        {...csvFile}
                      />
                      {UserType === "CLIENT" && (
                        <Button
                          className="Master_Card_Filter_Button w-100"
                          sx={{ width: "130px", height: "40px", gap: "8px" }}
                          startIcon={
                            <CloudUploadOutlinedIcon
                              sx={{ color: "#344054" }}
                            />
                          }
                          onClick={() => setBulkUploadOpen(true)}
                        >
                          Bulk Upload
                        </Button>
                      )}
                      {UserType === "CLIENT" && (
                        <Button
                          className="Master_Card_Filter_Button w-100"
                          sx={{ width: "150px", height: "40px", gap: "8px" }}
                          startIcon={<HistoryIcon sx={{ color: "#344054" }} />}
                          onClick={() => setHistoryOpen(true)}
                        >
                          Uploaded Files
                        </Button>
                      )}
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    autoApply={false}
                    alwaysOpen={true}
                    sx={{
                      "& .filter-box-container": {
                        boxShadow: "none",
                        border: "none",
                        p: 0,
                      },
                      "& .MuiPaper-root": {
                        boxShadow: "none",
                        border: "none",
                        p: 0,
                      },
                    }}
                  />
                </Box>
              )}

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>

              <Grid
                container
                alignItems={"center"}
                justifyContent={"flex-end"}
                margin={1}
              >
                <Grid item xs={12} sm={4} md={3.1}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    onChange={(e) => {
                      setQueryParam((queryParams) => ({
                        ...queryParams,
                        page: 0,
                        limit: 10,
                        skip: 0,
                        search: e.target.value,
                      }));
                    }}
                    disableUnderline={true}
                    placeholder="Search "
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>

              <MasterCommonTable
                tableConfig={tableConfig}
                data={policyList.map((data) => ({
                  _id: data?._id,
                  issueData:
                    data?.filterType === "APPROVE_DATE"
                      ? data?.commisionRecievable?.createdAt
                      : data?.issueDate,
                  issueDateFormate:
                    data?.filterType === "APPROVE_DATE"
                      ? "DD-MM-YYYY LT"
                      : undefined,
                  companyName: data?.companyId?.shortName,
                  policyNumber: data?.policyNumber,
                  customerName: data?.customerName,
                  product: data?.productId?.product,
                  policyType: data?.policyTypeId?.policyType,
                  registerationNumber: data?.registrationNumber,
                  paymentMode: data?.paymentMode,
                  receivableAmount: data?.commisionRecievable?.Total,
                  isCommisionRecievable: data?.isCommisionRecievable,
                  isEdit:
                    data?.status == "cancelled"
                      ? false
                      : data?.isCommisionRecievable,
                  isApprove:
                    data?.status == "cancelled"
                      ? false
                      : !data?.isCommisionRecievable,
                  isView: true,
                  dynamicAction: true,
                  data: data,
                }))}
                columns={headCells}
                handleOnClickBehaviour={OpenPolicyFile}
                handleEdit={ApproveFunction}
                handleApprove={ApproveFunction}
                handleView={GetPolicyFindbyIdFunction}
                isServerSide={true}
                tableTotalCount={totalCount}
                tableOutputEvent={(params) => {
                  setQueryParam({
                    page: params.page,
                    limit: params.limit,
                    skip: params.page * params.limit,
                    sort: params.sort,
                    search: queryParam.search,
                    isPaginationEnabled: true,
                  });
                }}
                loading={openLoader}
              />
            </Grid>
          </Box>
        </Box>
      </div>
      <Drawer
        open={openDrawer}
        sx={{
          zIndex: 100,
        }}
        anchor="right"
        PaperProps={{
          sx: {
            width: { xs: "100%", sm: "650px", md: "650px" },
          },
        }}
      >
        {openDrawer ? (
          <CommonPayableDrawer
            ReceivablePayablePercentage={payablePercentage}
            setOpenDrawer={setOpenDrawer}
            formType={formType}
            selectedData={selectedData}
            path={"commisionReceivable"}
            GetData={GetData}
            payableType={payableType}
            editType={editType}
          />
        ) : null}
      </Drawer>

      <BulkUploadPayableDialog
        open={bulkUploadOpen}
        setOpen={setBulkUploadOpen}
        onSuccess={() => GetData()}
        title="Bulk Upload Commision Receivable"
        templateHeaders={COMMISION_RECEIVABLE_TEMPLATE_HEADERS}
        templateFileName="Commision_Receivable_Bulk_Upload_Template.xlsx"
        verifyService={VerifyCommisionReceivableBulkUpload}
        commitService={BulkUploadCommisionReceivable}
      />

      <BulkUploadHistoryDialog
        open={historyOpen}
        setOpen={setHistoryOpen}
        defaultType="Commisionreceivable"
        title="Commision Receivable — Bulk Upload History"
      />
      {/* <Loader open={openLoader} /> */}
    </>
  );
};
export default CommisionReceivable;
